

import React, {Component} from 'react';
import { Transfer, Tree } from 'antd';
import * as Actions from "../../../actions/allResources";
import PropTypes from "prop-types";

const { TreeNode } = Tree;

// Customize Table Transfer
const isChecked = (selectedKeys, eventKey) => {
    return selectedKeys.indexOf(eventKey) !== -1;
};
const generateTree = (treeNodes = [], checkedKeys = []) => {
    return treeNodes.map(({ children, ...props }) => (
        <TreeNode {...props} disabled={checkedKeys.includes(props.key)} key={props.key}>
            {generateTree(children, checkedKeys)}
        </TreeNode>
    ));
};
const TreeTransfer = ({ dataSource, targetKeys, ...restProps }) => {
     const transferDataSource = [];
     function flatten(list = []) {
         list.forEach(item => {
             item.key =''+item.id;
             item.title = item.name;
             transferDataSource.push(item);
             flatten(item.children);
         });
     }
     flatten(dataSource);

 let renderSon = (params) => {

    let { direction, onItemSelect, selectedKeys } = params;

    if (direction === 'left') {
        const checkedKeys = [...selectedKeys, ...targetKeys];
        return (
            <Tree
                blockNode
                checkable

                checkStrictly
                defaultExpandAll
                checkedKeys={checkedKeys}
                onScroll={handleScroll}
                onCheck={(
                    _,
                    {
                        node: {
                            props: { eventKey },
                        },
                    },
                ) => {
                    onItemSelect(eventKey, !isChecked(checkedKeys, eventKey));
                }}
                onSelect={(
                    _,
                    {
                        node: {
                            props: { eventKey },
                        },
                    },
                ) => {
                    onItemSelect(eventKey, !isChecked(checkedKeys, eventKey));
                }}
            >
                {generateTree(dataSource, targetKeys)}
            </Tree>
        );
    }
};
let  handleScroll = (direction, e) => {
};

    return (
        <Transfer
            {...restProps}
            targetKeys={targetKeys}
            dataSource={transferDataSource}
            className="tree-transfer"
            render={item => item.name}
            showSelectAll={false}
        >
            {
                renderSon
            }
        </Transfer>
    );
};
export class Department extends Component {
    static defaultProps = {
        targetKeys:[],
    };
    static propTypes = {
        targetKeys:PropTypes.array,
    };

    constructor(props) {
        super(props);
        this.state = {
            treeData:[],
            targetKeys:this.props.targetKeys,
        };
    }

    componentDidMount() {
        this.state.targetKeys =[];

        Actions.deptAll( (data) => {
            this.setState({treeData:data.data})
        });
    }

    render() {
        return(
            <div id={'classification'}>
                <TreeTransfer dataSource={this.state.treeData} onScroll={this.handleScroll} targetKeys={this.state.targetKeys} onChange={this.TransferChange} onSelectChange={this.onSelectChange}/>
                <style>{
                    ` 
                    #classification .ant-transfer-list-body-customize-wrapper{height:380px }   
                      #classification .ant-transfer-list-body-customize-wrapper{overflow-y: auto;}        
                     #classification .ant-transfer-list-content  {height:420px} 
                     #classification .tree-transfer{height:480px}   
                    `
                }</style>
            </div>
        )
    }
    handleScroll = (direction, e) => {
    };
    TransferChange = (targetKeys, direction, moveKeys)=>{
        this.props.callbackData&&this.props.callbackData(targetKeys);
        this.setState({targetKeys});
    };

}



